module.exports = __webpack_public_path__ + "static/media/greenhouseStep7-2.ee67a7c8.jpg";